'use client';

import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';

import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import { NextImage } from '~components/NextImage/NextImage';
import { getLocaleDate } from '~helpers/date/getDate';
import ArrowIcon from '~public/static/images/icons/arrows/Arrow_Right_LG.svg';

import styles from './ArticleCardSmall.module.scss';
import { ArticleCardSmallProps } from './ArticleCardSmall.types';

export function ArticleCardSmall({
  className,
  title,
  publishedAt,
  image,
  href,
  mods,
  onClick,
}: ArticleCardSmallProps) {
  return (
    <article
      className={classNames(
        className,
        styles.card,
        mods?.map((mod) => styles[mod]),
      )}
    >
      {!publishedAt && <CardDraftLabel />}
      {image && (
        <div className={styles.media}>
          <NextImage className={styles.image} {...image} />
        </div>
      )}

      <div className={styles.content}>
        <div>
          <Typography
            tagName={TypographySizes.div}
            mods={[TypographyMods.bodyM]}
            className={styles.date}
          >
            {getLocaleDate(new Date(publishedAt)).replace(' г.', '')}
          </Typography>
          <Typography
            tagName={TypographySizes.h3}
            className={styles.title}
            mods={[TypographyMods.titleL]}
          >
            {title}
          </Typography>
        </div>
        <div className={styles.buttonContainer}>
          <Link className={styles.link} href={href} onClick={onClick}>
            Читать <ArrowIcon />
          </Link>
        </div>
      </div>
    </article>
  );
}
